import { render, staticRenderFns } from "./CheckboxTagsTree.vue?vue&type=template&id=4ddb1159"
import script from "./CheckboxTagsTree.vue?vue&type=script&lang=js"
export * from "./CheckboxTagsTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports